import React, { useState } from 'react';
import './Doctors.css';
import useAuth from '../hooks/useAuth';
import PainAssessment from './PainAssessment';

function Diagnosis({ patientCard }) {
  const { auth } = useAuth();
  const [outerTab, setOuterTab] = useState(0);
  const [innerTab, setInnerTab] = useState(0);

  const fullTabs = [
    { name: 'Cervical (Neck)', componentKey: 'Cervical' },
    { name: 'UpperBack', componentKey: 'UpperBack' },
    { name: 'Shoulder', componentKey: 'Shoulder' },
    { name: 'Arm', componentKey: 'Arm' },
    { name: 'Wrist', componentKey: 'Wrist' },
    { name: 'Chest', componentKey: 'Chest' },
    { name: 'MiddleBack', componentKey: 'MiddleBack' },
    { name: 'LowerBack & Pelvis', componentKey: 'LowerBack' },
    { name: 'Coccyx', componentKey: 'Coccyx' },
    { name: 'Thigh', componentKey: 'Thigh' },
    { name: 'Knee', componentKey: 'Knee' },
    { name: 'Calf', componentKey: 'Calf' },
    { name: 'Leg', componentKey: 'Leg' },
    { name: 'Ankle', componentKey: 'Ankle' },
    { name: 'Foot', componentKey: 'Foot' },
    { name: 'Lungs', componentKey: 'Lung' },
    { name: 'Heart', componentKey: 'Heart' },
    { name: 'Abdomen', componentKey: 'Abdomen' },
    { name: 'Digestive', componentKey: 'Digestive' },
    { name: 'Reproductive', componentKey: 'Reproductive' },
    { name: 'Renal', componentKey: 'Renal' },
    { name: 'Other', componentKey: 'Other' },
  ];

  const groupedTabs = [
    {
      name: 'Head Cervical Shoulders Arms',
      tabs: fullTabs.filter(t =>
        ['Cervical (Neck)', 'UpperBack', 'Shoulder', 'Arm', 'Wrist', 'Chest'].includes(t.name)
      ),
    },
    {
      name: 'Spine Pelvis',
      tabs: fullTabs.filter(t =>
        ['MiddleBack', 'LowerBack & Pelvis', 'Coccyx'].includes(t.name)
      ),
    },
    {
      name: 'Leg',
      tabs: fullTabs.filter(t =>
        ['Thigh', 'Knee', 'Calf', 'Leg'].includes(t.name)
      ),
    },
    {
      name: 'Foot',
      tabs: fullTabs.filter(t =>
        ['Ankle', 'Foot'].includes(t.name)
      ),
    },
    {
      name: 'Respiratory',
      tabs: fullTabs.filter(t => ['Lungs'].includes(t.name)),
    },
    {
      name: 'Physiology',
      tabs: fullTabs.filter(t =>
        ['Heart', 'Abdomen', 'Digestive', 'Reproductive', 'Renal', 'Other'].includes(t.name)
      ),
    },
  ];

  const bodyPartsCountMap = {
    Ankle: 2,
    Foot: 2,
    Shoulder: 2,
    Wrist: 2,
    Arm: 2,
    Leg: 2,
    Thigh: 2,
    Knee: 2,
    Calf: 2,
    Eye: 2,
    Lungs: 2,
    Cervical: 1,
    UpperBack: 1,
    Chest: 1,
    MiddleBack: 1,
    LowerBack: 1,
    Coccyx: 1,
    Heart: 1,
    Abdomen: 1,
    Digestive: 1,
    Reproductive: 1,
    Renal: 1,
    Other: 2,
  };

  const tabButtonStyle = (isSelected) => ({
    padding: '8px 14px',
    border: '1px solid #007bff',
    borderRadius: '4px',
    backgroundColor: isSelected ? '#007bff' : '#f0f8ff',
    color: isSelected ? '#fff' : '#007bff',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'all 0.2s',
    whiteSpace: 'nowrap',
    flexShrink: 0, // Prevent shrinking inside flex container
  });

  const tabContainerStyle = {
    display: 'flex',
    flexWrap: 'nowrap',      // No wrapping, single line
    overflowX: 'auto',       // Enable horizontal scroll
    marginBottom: '12px',
    paddingBottom: '6px',    // spacing below for scrollbar
    gap: '8px',              // spacing between buttons
  };

  const renderTabButton = (label, index, isSelected, onClick) => (
    <button
      key={index}
      className={`tab-button ${isSelected ? 'active' : ''}`}
      style={tabButtonStyle(isSelected)}
      onClick={onClick}
      type="button"
    >
      {label}
    </button>
  );

  return (
    <div style={{ padding: '12px', maxWidth: '80%' }}>
      {/* Outer Tabs */}
      <div className="tab-button-container" style={tabContainerStyle}>
        {groupedTabs.map((group, i) =>
          renderTabButton(group.name, i, outerTab === i, () => {
            setOuterTab(i);
            setInnerTab(0); // reset inner tab when outer tab changes
          })
        )}
      </div>

      {/* Inner Tabs */}
      <div className="tab-button-container" style={tabContainerStyle}>
        {groupedTabs[outerTab].tabs.map((tab, index) =>
          renderTabButton(tab.name, index, innerTab === index, () => setInnerTab(index))
        )}
      </div>

      {/* Content */}
      <div>
        <PainAssessment
          patientCard={patientCard}
          stype={groupedTabs[outerTab].tabs[innerTab].componentKey}
          bodyPartsCount={bodyPartsCountMap[groupedTabs[outerTab].tabs[innerTab].componentKey] || 1}
        />
      </div>
    </div>
  );
}

export default Diagnosis;
